import React from "react";
import { Container, makeStyles, Paper, Typography } from "@material-ui/core";

import MetMask from "../assets/images/MetaMask.png";

const configs = require("../configs.json");

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperContainer: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(5),
    maxWidth: 500,
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
  },
  metaMask: {
    width: "108px",
    marginLeft: "-40px",
  },
}));

function ConnectWalletPage() {
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Paper elevation={0} className={classes.paperContainer}>
        <div className="d-flex align-items-center justify-content-center mb-4">
          <img
            src={configs.theme.logo.smallLogo}
            alt="logo"
            className="big-simple-logo"
          />
          <img src={MetMask} alt="MetaMask" className={classes.metaMask} />
        </div>
        <Typography variant="h5" className={classes.title}>
          Connect To Wallet
        </Typography>
        <Typography variant="h6" className="text-center">
          Please connect an{" "}
          <a
            href="https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn"
            target="_blank"
            rel="noopener noreferrer"
          >
            MetaMask
          </a>{" "}
          wallet to your browser to use the application
        </Typography>
        <Typography variant="h6" className="text-center mb-0 mt-4">
          If you are in application, reload or click <a href="">here</a>
        </Typography>
      </Paper>
    </Container>
  );
}

export default ConnectWalletPage;
